import styled from 'styled-components'
import { MessageErrorUnstyled } from './unstyled'

export const MessageErrorInput = styled(MessageErrorUnstyled)`
  color: ${props => props.theme.colors.red};
  margin-top: 8px;
  margin-left: 10px;
  font-size: ${props => props.theme.fontSizes.form.messageErrorInput};
`
